import { emitCheckBoxEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex, checked) => {
  const { labels } = widgetTracking;

  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: checked ? 'selected' : 'deselected',
    labels: {
      ...labels,
      promo_FeatureNumber: ['99']
    }
  };
};
const buildProductTrackingData = (productTracking, checked) => ({
  ...productTracking,
  status: checked ? 'selected' : 'deselected'
});

export default (
  widgetTracking,
  additionalWidgetClickTracking,
  productTracking,
  additionalProductClickTracking,
  featureIndex,
  checked
) => {
  const event = {
    name: checked ? 'select' : 'deselect',
    features: [
      buildWidgetTrackingData(widgetTracking, featureIndex, checked),
      buildProductTrackingData(productTracking, checked)
    ]
  };

  const additionalClickTrackingLabels = {
    ...additionalWidgetClickTracking,
    'wk.promo_AttributionFeature': ['Bundles_DetailView'],
    ...additionalProductClickTracking
  };
  emitCheckBoxEvent(event, additionalClickTrackingLabels);
};
